import React, { useState } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useHandleVerifyRequestMutation } from '../../../redux/features/profileSlice';
import { useEffect } from 'react';

function DecisionModal({showModal, title='تأكيد', bodyText='هل أنت متأكد من اتخاذ هذا القرار؟', handleCloseModal ,decision, selectedRequest}) {


  const [note, setNote] = useState("")
  const [qidNumber, setQidNumber] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')

  console.log(selectedRequest?.profile.qid_number)

  const [handleVerifyRequest, {isLoading}  ] = useHandleVerifyRequestMutation();

  const handleConfirm = async(e) => {
    e.preventDefault()
    let decisionObj = {
      request_id:selectedRequest.id,
      decision,
      handler_notice:note,
      qid_number:qidNumber,
      phone_number:phoneNumber
    }
    console.log(decisionObj)
    try {
      await handleVerifyRequest(decisionObj).unwrap()
      handleCloseModal()
      setNote('')
    } catch (err) {
        console.error('Failed to save the changes', err)
    }
    
  }


  useEffect(()=>{
    if(selectedRequest?.profile.phone_number) {
      setPhoneNumber(selectedRequest?.profile.phone_number)
    }
    if(selectedRequest?.profile.qid_number) {
      setQidNumber(selectedRequest?.profile.qid_number)
    }
  },[selectedRequest])


  
  return (
    <Modal show={showModal} onHide={handleCloseModal} scrollable>
        <Modal.Header className='bg-dark'>
          <Modal.Title className='fs-5 text-white mb-0'>{title}</Modal.Title>
          <Button variant="light" className="mb-0" size="sm" onClick={handleCloseModal} aria-label="Close"><i class="bi bi-x-lg"></i></Button>
        </Modal.Header>
        <Modal.Body>
            {bodyText}
            <Form>
              {decision ==='approved' ?
               <>
               <Form.Group
                className="my-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>رقم الهوية</Form.Label>
                <Form.Control  
                  placeholder="اكتب رقم الهوية هنا"
                  className="border-0 bg-light rounded-end px-2"
                  name='qid_number'
				          onChange={(e)=> setQidNumber(e.target.value)}
                  value={qidNumber}
                 />
              </Form.Group>
              <Form.Group
                className="my-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Label>رقم الجوال</Form.Label>
                <Form.Control  
                  placeholder="اكتب رقم الجوال هنا"
                  className="border-0 bg-light rounded-end px-2 dr-ltr-right"
                  name='qid_number'
				          onChange={(e)=> setPhoneNumber(e.target.value)}
                  value={phoneNumber}
                  autoFocus
                 />
              </Form.Group></> :
               <Form.Group
               className="my-3"
               controlId="exampleForm.ControlTextarea1"
             >
               <Form.Label>ملاحظة </Form.Label>
               <Form.Control  
                 as="textarea" 
                 rows={3}
                 placeholder="اكتب ملاحظاتك هنا"
                 className="border-0 bg-light rounded-end px-2"
                 name='note'
                 onChange={(e)=> setNote(e.target.value)}
                 value={note}
                 autoFocus
                />
             </Form.Group> 
              }
              
             
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button className='my-0' variant={decision ==='approved' ? "danger-soft" : "outline-primary"} onClick={handleCloseModal}>
            إلغاء
          </Button>
          {isLoading ?
          <Button className='my-0' variant={decision ==='approved' ? "outline-primary" : "danger-soft"} disabled>
          <Spinner
            as="span"
            animation="grow"
            size="sm"
            role="status"
            aria-hidden="true"
          />
           {' يتم التحميل...'}
          </Button> :
          <Button className='my-0' variant={decision ==='approved' ? "outline-primary" : "danger-soft"} onClick={handleConfirm}>
            تأكيد
          </Button>}
        </Modal.Footer>
    </Modal>
  )
}

export default DecisionModal